<template>
    <div>
        <app-bar></app-bar>
        <v-container fluid v-intersect="{handler: showToolbar, options: {
           rootMargin:'0px 0px -100px 0px',
           threshold: [0.25]
        }}">
            <v-row>
                <template v-if="!loading">
                    <v-col v-for="card in getMenu" :key="card.title" :cols="card.flex">
                        <v-card :disabled="card.disabled" :to="card.to" :dark="card.dark"
                            :color="!card.disabled ? card.bgColor : 'grey darken-2'" class="text-center pa-5"
                            elevation="12">
                            <div>
                                <v-badge v-model="card.badge" overlap dot value="1" color="deep-orange darken-4">
                                    <v-icon x-large>{{card.icon}}</v-icon>
                                </v-badge>
                            </div>
                            <span class="small">{{card.subtitle ? card.subtitle : card.title}}</span>
                        </v-card>
                    </v-col>
                </template>
            </v-row>
        </v-container>

        <v-expand-transition leave-absolute hide-on-leave>
            <v-container v-if="toolbar" class="pa-0 ma-0 text-center sticky">
                <v-row no-gutters>
                    <template v-if="!card.disabled">
                        <v-col v-for="card in getMenu" :key="card.title">
                            <v-btn tile :to="card.to" :dark="card.dark" class="py-8" elevation="0" block
                                color="deep-purple darken-1">
                                <v-badge v-model="card.badge" overlap dot value="1" color="deep-orange darken-4">
                                    <v-icon>{{card.icon}}</v-icon><br>
                                    <small>{{card.title}}</small>
                                </v-badge>
                            </v-btn>
                        </v-col>
                    </template>
                </v-row>
            </v-container>
        </v-expand-transition>

        <partner show></partner>

        <!--Qui sotto inseriremo tutti i feed automatici-->

        <last-club></last-club>

    </div>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
    name: 'Home',
    components: {
        'lastClub': async () => import('../components/lastClub'),
        'partner': async () => import('../components/partner'),
    },
    data: () => ({
        toolbar: false,
        loading: true,
        appMenu: [],
        club_id: 0
    }),
    mounted() {
        this.appMenu = this.getAppMenu;
        this.club_id = parseInt(localStorage.getItem('_cID'));
        setTimeout(() => {
            this.loading = false;
        }, 500);
    },
    destroyed() {
        this.appMenu = [];
    },
    computed: {
        ...mapGetters([
            'getClubID',
            'getAppMenu'
        ]),
        getMenu() {
            this.appMenu.forEach((item, index) => {
                if (item.to === '/friendly' && this.club_id === 0) {
                    //state.mainmenu.splice(index,1);
                    item.disabled = true;
                }
            });
            return this.appMenu;
        }
    },
    methods: {
        showToolbar(entries, observer, isIntersecting) {
            if (!isIntersecting) {
                this.toolbar = true;
            } else {
                this.toolbar = false;
            }
        },
    }
}
</script>

<style scoped>
.sticky {
    position: fixed;
    top: 56px;
    z-index: 1;
}
.small{ font-size: 12px;}
</style>